import React, { useState } from 'react';
import { Star, Heart, MessageSquare, CheckCircle2 } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
const ALL_REVIEWS = [{
  user: '@lucia_sistemica',
  text: 'Increíble el material, ya estoy usando las frases sanadoras y los movimientos de solución en mis sesiones.',
  likes: 12,
  time: '2 horas'
}, {
  user: '@carla_consteladora',
  text: 'El protocolo de movimientos de solución es lo que me faltaba para cerrar bien las constelaciones. ¡Gracias!',
  likes: 8,
  time: '4 horas'
}, {
  user: '@ana_sanacion_familiar',
  text: 'Muy completo todo, el mapa de implicancias sistémicas está bárbaro para detectar lealtades invisibles.',
  likes: 15,
  time: '6 horas'
}, {
  user: '@facilitadora_orden',
  text: 'Las visualizaciones para tomar a los padres son de otro planeta. Mis consultantes quedan impactados.',
  likes: 21,
  time: '8 horas'
}, {
  user: '@constelaciones_mujeres',
  text: 'Por fin algo profesional y bien organizado para terapeutas sistémicos. Los genogramas en Canva son geniales.',
  likes: 34,
  time: '12 horas'
}, {
  user: '@sofi_orden',
  text: 'El mapa de lealtades invisibles me voló la cabeza. Muy recomendado para quienes buscan orden.',
  likes: 19,
  time: '1 día'
}, {
  user: '@paula_sistemica',
  text: 'Excelente soporte y el material sobre el campo morfogenético es de primera calidad.',
  likes: 7,
  time: '1 día'
}, {
  user: '@caro_holistica',
  text: 'Me sirvió mucho para entender las jerarquías y el equilibrio entre dar y recibir en mis grupos.',
  likes: 11,
  time: '2 días'
}, {
  user: '@espacio_sistemico_fem',
  text: 'Las fichas de genograma en Canva son súper fáciles de editar. Muy práctico para la consulta online.',
  likes: 25,
  time: '2 días'
}, {
  user: '@juana_consteladora',
  text: 'Un antes y un después en mi práctica profesional. El orden del amor ahora es mi guía diaria.',
  likes: 42,
  time: '3 días'
}, {
  user: '@marta_sanadora',
  text: 'Lo compré ayer y ya devoré la guía de movimientos de solución. ¡Es oro puro!',
  likes: 14,
  time: '3 días'
}, {
  user: '@vibrando_sistemico',
  text: 'El protocolo de protección para consteladoras es clave, ya no me cargo con los destinos ajenos.',
  likes: 28,
  time: '4 días'
}, {
  user: '@luz_sistemica',
  text: 'Muy agradecida por compartir este conocimiento sobre los órdenes del amor tan valioso.',
  likes: 16,
  time: '4 días'
}, {
  user: '@terapias_sistemicas_pro',
  text: 'El kit más completo que vi en mucho tiempo para trabajar la pertenencia. ¡Felicitaciones!',
  likes: 31,
  time: '5 días'
}, {
  user: '@ser_consciente_mujer',
  text: 'Las guías de post-sesión para integrar el movimiento sistémico son un plus increíble.',
  likes: 9,
  time: '5 días'
}];
export function Reviews() {
  const [reviews, setReviews] = useState(ALL_REVIEWS);
  const [likedIndices, setLikedIndices] = useState<number[]>([]);
  const [comment, setComment] = useState('');
  const [rating, setRating] = useState(0);
  const [showPopup, setShowPopup] = useState(false);
  const [visibleCount, setVisibleCount] = useState(3);
  const handlePublish = () => {
    if (comment.trim()) {
      const newReview = {
        user: '@usuario_nuevo',
        text: comment,
        likes: 0,
        time: 'ahora mismo'
      };
      setReviews([newReview, ...reviews]);
      setShowPopup(true);
      setComment('');
      setRating(0);
    }
  };
  const handleLike = (index: number) => {
    if (likedIndices.includes(index)) return;
    setReviews(prev => prev.map((rev, i) => i === index ? {
      ...rev,
      likes: rev.likes + 1
    } : rev));
    setLikedIndices([...likedIndices, index]);
  };
  const loadMore = () => {
    setVisibleCount(prev => Math.min(prev + 5, reviews.length));
  };
  return <section className="py-20 bg-blue-50 pt-[30px] pb-[30px]" data-id="element-286" data-mp="383sq7uraz3dx">
      <div className="max-w-3xl mx-auto px-4" data-id="element-287" data-mp="3d3f5e9qoytpd">
        <h2 className="text-[#d97706] font-['Dancing_Script',_cursive] text-[32px] md:text-5xl mb-10 text-center" data-id="element-288" data-mp="3d241m9x8xly9">
          comentarios de los que ya accedieron
        </h2>

        <div className="bg-white p-6 rounded-2xl border border-blue-100 mb-12 shadow-sm" data-id="element-289" data-mp="3n0tji2p576ei">
          <h3 className="text-blue-950 font-bold mb-4" data-id="element-290" data-mp="2pevvjprzu8v6">
            Deja tu reseña para la comunidad:
          </h3>
          <textarea value={comment} onChange={e => setComment(e.target.value)} placeholder="Escribe aquí tu experiencia con el Sistema de Constelaciones..." className="w-full bg-blue-50 border border-blue-100 rounded-xl p-4 text-blue-950 focus:border-blue-400 outline-none transition-colors mb-4 min-h-[100px]" data-id="element-291" data-mp="2udz25enmgn59" />
          <div className="flex flex-wrap items-center justify-between gap-4" data-id="element-292" data-mp="2bm69jlcgt3y2">
            <div className="flex items-center gap-2" data-id="element-293" data-mp="srla59b9nwkq">
              <span className="text-blue-400 text-sm" data-id="element-294" data-mp="sr1phku8eu30">Calificar:</span>
              <div className="flex gap-1" data-id="element-295" data-mp="opq822lihf5w">
                {[1, 2, 3, 4, 5].map(s => <button key={s} onClick={() => setRating(s)} className={`${rating >= s ? 'text-blue-600' : 'text-blue-200'} hover:scale-110 transition-transform`} data-id="element-296" data-mp="jq3ufs1rtwwk">
                    <Star size={20} fill={rating >= s ? 'currentColor' : 'none'} data-id="element-297" data-mp="9u0ijuh4ajwf" />
                  </button>)}
              </div>
            </div>
            <button onClick={handlePublish} className="bg-blue-950 text-white font-black px-8 py-3 rounded-full hover:bg-blue-800 transition-colors uppercase text-sm" data-id="element-298" data-mp="3s6oxks7q1vrr">
              Publicar
            </button>
          </div>
        </div>

        <div className="space-y-8" data-id="element-299" data-mp="3ialrxcdnvf02">
          {reviews.slice(0, visibleCount).map((rev, i) => <div key={i} className="border-b border-blue-100 pb-6" data-id="element-300" data-mp="38mzoi5hevxpi" data-mpi={i}>
              <div className="flex items-center justify-between mb-2" data-id="element-301" data-mp="3dkszdbtntfw4">
                <span className="text-blue-600 font-bold text-sm" data-id="element-302" data-mp="2zl091hm1p1oo">
                  {rev.user}
                </span>
                <div className="flex text-blue-600" data-id="element-303" data-mp="33mli0rvgkvtl">
                  {[...Array(5)].map((_, i) => <Star key={i} size={12} fill="currentColor" data-id="element-304" data-mp="3rcpjotp36lhy" data-mpi={i} />)}
                </div>
              </div>
              <p className="text-blue-900 mb-3" data-id="element-305" data-mp="77n1rvkby5l">{rev.text}</p>
              <div className="flex items-center gap-4 text-xs text-blue-400" data-id="element-306" data-mp="3ii1j3gughrzh">
                <button onClick={() => handleLike(i)} className={`flex items-center gap-1 transition-colors ${likedIndices.includes(i) ? 'text-pink-500' : 'hover:text-blue-600'}`} data-id="element-307" data-mp="3mk64xtenxkbk">
                  <Heart size={14} fill={likedIndices.includes(i) ? 'currentColor' : 'none'} data-id="element-308" data-mp="ix5vwa76pvaa" />{' '}
                  {rev.likes} Likes
                </button>
                <span data-id="element-309" data-mp="1ykudssgbb95m">hace {rev.time}</span>
              </div>
            </div>)}
          {visibleCount < reviews.length && <button onClick={loadMore} className="w-full py-4 text-blue-400 font-bold hover:text-blue-600 transition-colors uppercase text-sm tracking-widest" data-id="element-310" data-mp="28c6tymsr0avt">
              Cargar 5 comentarios más
            </button>}
        </div>
      </div>

      <AnimatePresence data-id="element-311" data-mp="1uluyqf0v9w0g">
        {showPopup && <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-blue-950/40 backdrop-blur-sm" data-id="element-312" data-mp="1ummvht679zsb">
            <motion.div initial={{
          scale: 0.9,
          opacity: 0
        }} animate={{
          scale: 1,
          opacity: 1
        }} exit={{
          scale: 0.9,
          opacity: 0
        }} className="bg-white border-2 border-blue-600 p-8 rounded-3xl max-w-sm w-full text-center shadow-2xl" data-id="element-313" data-mp="1polc174v3ygb">
              <div className="w-16 h-16 bg-blue-600 rounded-full flex items-center justify-center mx-auto mb-4 text-white" data-id="element-314" data-mp="18cmxf0refi4d">
                <CheckCircle2 size={32} data-id="element-315" data-mp="1d57jth7z6sxv" />
              </div>
              <h4 className="text-xl font-black text-blue-950 mb-2" data-id="element-316" data-mp="1i394g6l1v0bg">
                ¡Gracias por tu comentario!
              </h4>
              <p className="text-blue-800/60 mb-6" data-id="element-317" data-mp="1m305d34aiwtp">
                Tu opinión ayuda a la comunidad.
              </p>
              <button onClick={() => setShowPopup(false)} className="w-full bg-blue-950 text-white font-black py-3 rounded-xl uppercase text-sm" data-id="element-318" data-mp="1r47cr12ittzu">
                Cerrar
              </button>
            </motion.div>
          </div>}
      </AnimatePresence>
    </section>;
}